import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  TextField,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { UseB2BCustomer } from "./UseB2BCustomer";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function FilterSearch(props) {
  const [open, setOpen] = React.useState(false);
  const [searchState, setSearchState] = useState([]);
  const [add, setAdd] = useState("");
  const [orgenizeRes, setOrgenizeRes] = useState();
  const { getOrgenizationsList } = UseB2BCustomer();
  const [state, setState] = useState({
    orgenizeID: undefined,
    orgenizeTypeID: undefined,
    suspend: undefined,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    getOrgenizationsList((orgenizations) => {
      setOrgenizeRes(orgenizations);
    });
  }, []);

  const Suspends = [
    {
      id: 1,
      title: "فعال",
    },
    {
      id: 2,
      title: "معلق",
    },
  ];

  const orgenizeType = [
    {
      id: 2,
      title: "حقوقی",
    },
    {
      id: 1,
      title: "حقیقی",
    },
  ];

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">فیلترها : </Typography>
        <Tooltip title="افزودن">
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon
              sx={{
                color: "primary.main",
              }}
            />
          </IconButton>
        </Tooltip>
        <Box
          style={{ direction: "ltr", display: "flex", alignItems: "center" }}
        >
          {props.state.orgenizeID && (
            <Chip
              label={
                orgenizeRes.find((m) => m.id == props.state.orgenizeID)?.title
              }
              onDelete={(data) => {
                props.setState({
                  ...props.state,
                  orgenizeID: "",
                });
                setState({
                  ...state,
                  orgenizeID: "",
                });
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
          {props.state.orgenizeTypeID && (
            <Chip
              label={
                orgenizeType.find((m) => m.id == props.state.orgenizeTypeID)
                  ?.title
              }
              onDelete={(data) => {
                props.setState({
                  ...props.state,
                  orgenizeTypeID: "",
                });
                setState({
                  ...state,
                  orgenizeTypeID: "",
                });
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
          {props.state.suspend && (
            <Chip
              label={Suspends.find((m) => m.id == props.state.suspend)?.title}
              onDelete={(data) => {
                props.setState({ ...props.state, suspend: "" });
                setState({ ...state, suspend: "" });
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
        </Box>
      </Box>
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={() => setOpen(false)}
        open={open}
      >
        <Box
          sx={{ m: 3, my: 5 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
        >
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Autocomplete
              size="small"
              value={state.suspend ? state.suspend : ""}
              onChange={(event, newValue) => {
                if (newValue || newValue == 0) {
                  setState({ ...state, suspend: newValue });
                } else {
                  setState({ ...state, suspend: "" });
                }
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => {
                if (option) {
                  return Suspends.find((m) => m.id == option).title;
                }
                return "";
              }}
              options={Suspends ? Suspends.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField
                  sx={{ input: { textAlign: "center" } }}
                  variant="outlined"
                  {...params}
                  label="وضعیت"
                />
              )}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            {orgenizeRes && (
              <Autocomplete
                size="small"
                value={state.orgenizeID ? state.orgenizeID : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setState({ ...state, orgenizeID: newValue });
                  } else {
                    setState({ ...state, orgenizeID: undefined });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return orgenizeRes?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                fullWidth
                options={orgenizeRes?.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField variant="outlined" {...params} label="سازمان" />
                )}
              />
            )}
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            {orgenizeType && (
              <Autocomplete
                size="small"
                value={state.orgenizeTypeID ? state.orgenizeTypeID : ""}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setState({
                      ...state,
                      orgenizeTypeID: newValue,
                    });
                  } else {
                    setState({
                      ...state,
                      orgenizeTypeID: undefined,
                    });
                  }
                }}
                isOptionEqualToValue={(option, value) => {
                  return value == "" || option === value;
                }}
                getOptionLabel={(option) => {
                  if (option) {
                    return orgenizeType?.find((m) => m.id == option).title;
                  }
                  return "";
                }}
                fullWidth
                options={orgenizeType?.map((m) => m.id)}
                renderInput={(params) => (
                  <TextField
                    sx={{ input: { textAlign: "center" } }}
                    variant="outlined"
                    {...params}
                    label="نوع سازمان"
                  />
                )}
              />
            )}
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center", mx: "auto" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                props.setState(state);
                setOpen(false);
              }}
              sx={{ width: "70px", mr: 2 }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
              }}
              sx={{ width: "70px" }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
